import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkCreateClinicActTeam } from '../types';

const onCreateClinicActTeam: IThunkCreateClinicActTeam = thunk(async (_, { clinicId, actTeam }) => {
  await api.actTeam.createClinicActTeam(clinicId, actTeam);
});

export default onCreateClinicActTeam;
